var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCtLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 599.65 198.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".d{fill:#    ", /*#__PURE__*/React.createElement("style", null, "\n      .d { fill: #FFEDDC; stroke-width: 0px; }\n    "), ";stroke-width:0px;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "94.41 80.95 74.13 74.13 78.25 86.38 94.41 80.95"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "99.05 49.83 90.12 76.39 110.25 83.15 99.05 49.83"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "148.27 99.05 121.7 90.12 114.94 110.25 148.27 99.05"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "123.96 74.13 111.71 78.25 117.14 94.41 123.96 74.13"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "119.84 111.71 103.68 117.14 123.96 123.96 119.84 111.71"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "107.97 121.7 87.85 114.94 99.05 148.27 107.97 121.7"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "49.83 99.05 76.39 107.97 83.15 87.85 49.83 99.05"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "80.95 103.68 74.13 123.96 86.38 119.84 80.95 103.68"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M164.6,99.31c0-14.98,9.99-22.92,21.19-22.92,9.52,0,16.16,4.78,18.42,13.02l-7.34,2.48c-1.73-4.55-4.87-7.81-11.08-7.81-6.91,0-12.74,4.86-12.74,15.24s5.83,15.24,12.74,15.24c6.21,0,9.35-3.27,11.08-7.81l7.49,1.92c-2.11,8.58-8.83,13.57-18.57,13.57-11.2,0-21.19-7.94-21.19-22.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M208.38,105.58c0-9.35,6.02-16.64,16.39-16.64s16.39,7.3,16.39,16.64-6.02,16.65-16.39,16.65-16.39-7.3-16.39-16.65ZM232.84,105.58c0-5.31-2.94-9.86-8.07-9.86s-8.07,4.55-8.07,9.86,2.94,9.86,8.07,9.86,8.07-4.55,8.07-9.86Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M246.66,112.49v-23.05h7.94v20.68c0,3.84,1.92,5.32,4.61,5.32,3.84,0,7.36-4.61,7.36-13.12v-12.87h7.94v32.27h-7.94v-5.19c-2.37,3.39-5.83,5.7-9.99,5.7-5.76,0-9.92-3.27-9.92-9.73Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M282.01,121.71v-32.27h7.94v5.18c2.37-3.39,5.83-5.7,9.99-5.7,5.76,0,9.92,3.27,9.92,9.73v23.05h-7.94v-20.68c0-3.84-1.92-5.31-4.61-5.31-3.84,0-7.36,4.61-7.36,13.12v12.87h-7.94Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M318.65,110.32v-14.08h-4.99v-6.79h4.99v-10.39l7.94-2.67v13.06h8.52v6.79h-8.52v13.96c0,3.97,1.54,5.25,4.23,5.25,1.09,0,1.99-.19,3.07-.77l1.86,6.4c-1.79.83-3.52,1.15-5.25,1.15-7.3,0-11.84-3.91-11.84-11.91Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M368.11,108.14h-22.28c.7,4.93,3.65,7.3,7.68,7.3,3.65,0,5.89-1.67,7.81-4.99l6.4,2.37c-2.5,5.7-6.85,9.41-14.66,9.41-11.08,0-15.49-9.03-15.49-16.65s4.42-16.64,15.49-16.64,15.05,8.9,15.05,15.94v3.27ZM359.98,101.87c-.71-3.2-2.69-6.15-6.91-6.15-3.39,0-6.02,2.11-7.04,6.15h13.96Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M374,121.71v-32.27h7.94v5.25c2.3-3.78,5.89-5.76,9.54-5.76,1.41,0,2.62.26,3.9.64l-1.47,7.36c-.96-.57-1.98-.9-3.33-.9-4.61,0-8.64,3.78-8.64,14.21v11.46h-7.94Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M420.15,121.71v-37.13h-12.48v-7.68h33.29v7.68h-12.48v37.13h-8.32Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M437.88,105.58c0-9.35,6.02-16.64,16.39-16.64s16.39,7.3,16.39,16.64-6.02,16.65-16.39,16.65-16.39-7.3-16.39-16.65ZM462.33,105.58c0-5.31-2.94-9.86-8.07-9.86s-8.07,4.55-8.07,9.86,2.94,9.86,8.07,9.86,8.07-4.55,8.07-9.86Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M474.81,105.58c0-9.35,6.02-16.64,16.39-16.64s16.39,7.3,16.39,16.64-6.02,16.65-16.39,16.65-16.39-7.3-16.39-16.65ZM499.26,105.58c0-5.31-2.94-9.86-8.07-9.86s-8.07,4.55-8.07,9.86,2.94,9.86,8.07,9.86,8.07-4.55,8.07-9.86Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M513.15,121.71v-42.66l7.94-2.67v45.33h-7.94Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M526.01,113.52l6.34-3.39c1.15,3.14,3.27,5.32,6.4,5.32,1.86,0,3.71-.96,3.71-3.14s-3.27-3.52-6.66-4.87c-4.48-1.79-7.68-4.48-7.68-9.47s4.22-9.03,10.18-9.03c4.35,0,8.13,1.92,10.12,5.25l-4.74,4.35c-1.41-2.05-3.2-2.82-5.18-2.82-1.6,0-3.14.9-3.14,2.43,0,1.41,1.15,2.56,6.59,4.55,4.61,1.66,7.88,4.29,7.88,9.09,0,6.34-4.61,10.44-11.01,10.44-7.17,0-11.52-4.42-12.8-8.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtLogo);
export default __webpack_public_path__ + "static/media/ct-logo.ffc840405e898d74db2971112ab66fd7.svg";
export { ForwardRef as ReactComponent };